const Eye = ({ stroke = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M1.5 8s2.4-4.5 6.5-4.5S14.5 8 14.5 8 12.1 12.5 8 12.5 1.5 8 1.5 8z"
      stroke={stroke}
      strokeWidth="1.3"
    />
    <circle cx="8" cy="8" r="2.2" stroke={stroke} strokeWidth="1.3" />
  </svg>
);

export default Eye;
